// Convert customFields object to an array.
import { safeJSON } from '@utmost.co/utmost-design-system';

export function normalizeModel(object: any, keepEmptyArrays = false): any {
  return sanitize(
    safeJSON.fromString(
      JSON.stringify(object, (key, value) => {
        if (key === 'customFields') {
          return Object.values(value).filter((value) => !!value) ?? [];
        }
        if (key.startsWith('$')) {
          return undefined;
        }
        return value === null
          ? null
          : value === '' || (typeof value === 'string' && value.trim() === '')
            ? ''
            : typeof value === 'object' &&
                Object.values(value).filter((v) => v === null || typeof v !== 'undefined').length === 0 &&
                value !== object
              ? keepEmptyArrays && Array.isArray(value)
                ? []
                : undefined
              : typeof value === 'string'
                ? value.trim()
                : value;
      })
    )
  );
}

function sanitize(values: any): any {
  return { ...values, meta: undefined };
}
